import MarketProductsService from '@/services/bankwatch/MarketProductsService';

const marketProductsService = new MarketProductsService();

export const actions = {
  async getAllMarketProducts({ commit }: { commit: Function }) {
    commit('setIsFetching', true);
    commit('setError', null);
    try {
      const products = await marketProductsService.getAllMarketProducts();
      commit('setAllMarketProducts', products);
    } catch (error: any) {
      commit('setError', error.message || 'Failed to fetch market products');
      throw error;
    } finally {
      commit('setIsFetching', false);
    }
  },

  async getMarketProductByOrgId({ commit }: { commit: Function }, orgId: string) {
    commit('setIsFetching', true);
    commit('setError', null);
    try {
      const product = await marketProductsService.getMarketProductByOrgId(orgId);
      commit('setSelectedMarketProduct', product);
      return product;
    } catch (error: any) {
      commit('setError', error.message || 'Failed to fetch market product');
      throw error;
    } finally {
      commit('setIsFetching', false);
    }
  },

  clearSelectedMarketProduct({ commit }: { commit: Function }) {
    commit('setSelectedMarketProduct', null);
  },

  clearError({ commit }: { commit: Function }) {
    commit('setError', null);
  }
};
